import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { useQuotationForm } from './hook';
import { QuotationCallInfo } from './callInfo';
import FormView from '../../../../components/views/formView';
import { QuotationFormProps } from './props';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';
import { RootState } from '../../../../../redux/store';
import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { QUOTATION, QUOTATION_DETAIL } from '../../../../../routes/paths';

export const QuotationForm = ({ showFormView }: QuotationFormProps) => {
    const {
        quotationDetail,
        loading,
        handleSubmit,
        handleClean,
        setFormikQuotation,
    } = useQuotationForm();

    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const restrictedRoles = ['agent', 'backoffice', 'agente-conmutador'];
    const isRestrictedRole = restrictedRoles.includes(type);
    const [showHistorical, setShowHistorical] = useState(false);
    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const additionalButtons =
        !isSupervisor(type) && !isOnlyViewProfile(type) ? (
            <ActionButtonGroup
                id={quotationDetail?.id || ''}
                buttonSearch={{
                    show: true,
                    route: QUOTATION,
                }}
                buttonView={{
                    show: !isOnlyViewProfile(type),
                    route: QUOTATION_DETAIL,
                }}
                buttonLog={{
                    show: false,
                }}
                onHistoricalShow={toggleHistorical}
            />
        ) : undefined;

    return (
        <>
            {showFormView && (
                <FormView
                    title={
                        quotationDetail && quotationDetail.id
                            ? 'Editar Cotización'
                            : 'Crear Cotización'
                    }
                    additionalButtons={additionalButtons}
                />
            )}
            <QuotationCallInfo
                data={quotationDetail}
                onChangeFormik={(formik) => setFormikQuotation(formik)}
                isRestrictedRole={isRestrictedRole}
            />
            <Grid item xs={12} mt={5} mb={10}>
                <LoadingButtonGeneral
                    disabled={loading}
                    loading={loading}
                    title="Guardar"
                    sx={{ mr: 1 }}
                    onClick={handleSubmit}
                />
                {(!quotationDetail || !quotationDetail.id) && (
                    <LoadingButtonGeneral
                        disabled={loading}
                        title="Limpiar"
                        variant="outlined"
                        onClick={handleClean}
                    />
                )}
            </Grid>
        </>
    );
};
